import React from 'react';
import { useSelector } from 'react-redux';
import { useHotkeys } from 'react-hotkeys-hook';
import { keyboardActions } from 'features/keyboard/keyboardSlice';
import { ActiveFocusItemName } from 'features/keyboard/keyboardSliceTypes';
import {
  selectInputImportant,
  selectComment,
  selectActiveEventTypeId,
  inputSliceActions,
} from 'features/input/inputSlice';
import { selectTime } from 'features/time/timeSlice';
import { MatchEventType } from '../../enums/matchEventType';
import { modalsActions, selectInfoModal } from '../../features/modals/modalsSlice';
import { matchSliceActions } from '../../features/match/matchSlice';
import publishOrUpdateEvent from '../../features/input/thunks/publishOrUpdateEvent';
import { useAppDispatch } from '../../hooks/hooks';

const HotKeys: React.FC = () => {
  const dispatch = useAppDispatch();

  const time = useSelector(selectTime);
  const activeMatchEventTypeId = useSelector(selectActiveEventTypeId);
  const comment = useSelector(selectComment);
  const disableSubmit =
    activeMatchEventTypeId &&
    [MatchEventType.COMMENT, MatchEventType.INJURY_TIME, MatchEventType.MATCH_SUMMARY].includes(
      activeMatchEventTypeId,
    ) &&
    (!comment || (comment && typeof comment === 'string' && comment.trim() === ''));
  const important = useSelector(selectInputImportant);
  const infoModal = useSelector(selectInfoModal);

  useHotkeys(
    'ctrl+alt+h',
    () => {
      dispatch(keyboardActions.setActiveFocusItem(ActiveFocusItemName.HOME_GOAL));
    },
    {
      enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
    },
  );
  useHotkeys(
    'ctrl+alt+b',
    () => {
      dispatch(keyboardActions.setActiveFocusItem(ActiveFocusItemName.AWAY_GOAL));
    },
    {
      enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
    },
  );
  useHotkeys(
    'ctrl+alt+f',
    () => {
      dispatch(keyboardActions.setActiveFocusItem(ActiveFocusItemName.COMMENT));
    },
    {
      enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
    },
  );
  useHotkeys(
    'ctrl+alt+n',
    () => {
      dispatch(matchSliceActions.clearActiveMatchEvents());
      dispatch(inputSliceActions.clearActiveSelect());
      dispatch(inputSliceActions.setEventTime(time.minutes + ':' + time.seconds.toString().padStart(2, '0')));
      dispatch(inputSliceActions.newEvent());
      dispatch(keyboardActions.setActiveFocusItem(ActiveFocusItemName.COMMENT));
    },
    {
      enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
    },
    [time],
  );
  useHotkeys(
    'ctrl+alt+p',
    () => {
      if (!disableSubmit) {
        dispatch(publishOrUpdateEvent({}));
      }
    },
    {
      enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
    },
    [disableSubmit],
  );
  useHotkeys(
    'ctrl+alt+v',
    () => {
      dispatch(inputSliceActions.setImportant(!important));
    },
    {
      enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
    },
    [important],
  );
  useHotkeys(
    'ctrl+alt+i',
    () => {
      dispatch(modalsActions.setInfoModal(!infoModal));
    },
    {
      enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
    },
  );
  return <></>;
};

export default HotKeys;
